export const storeDataTypes = {
    ADD_DATA: "ADD_DATA",
    REMOVE_DATA: "REMOVE_DATA",
}